import { connect } from 'react-redux'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import { BaseScreenTableSimpleStateless, useBaseScreenTableLogic } from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import TableCustomers from '../../../../../../specificComponents/Customers/TableCustomersB2C'
import withLoading from '../../../../../../utils/hoc/withLoading'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import { EmployeesPayload } from '../../../../../../utils/reducers/company/employees'
import ModalCreateCustomer from './ModalCreateCustomer'
import { customerTypes, CustomerTypesInversedKeys } from '@teinor/erp/types/company/customer/customerTypes'
import useUpdateTableInstance from '../../../../../../utils/hooks/useUpdateTableInstance'
import RightHeaderTableCustomers from '../../../../../../specificComponents/Customers/RightHeaderTableCustomers'

interface CustomersProps extends ComponentWithPermissions {}

const Customers: React.FC<CustomersProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const { openModal, setOpenModal, tableInstance, setTableInstance } = useBaseScreenTableLogic()
    const { updateTableInstance } = useUpdateTableInstance({ tableInstance })
    const pageData = {
        title: t('customers', 'Clientes'),
        newText: t('newCustomer', 'Nuevo cliente'),
    }

    return (
        <BaseScreenTableSimpleStateless TableComponent={TableCustomersConnect} {...{ pageData, userPermissions, updateTableInstance }} CreateModalComponent={ModalCreateCustomer} logicProps={{ openModal, setOpenModal, tableInstance, setTableInstance }} RightHeader={
            <RightHeaderTableCustomers typeCustomer={customerTypes['B2C'] as CustomerTypesInversedKeys}  {...{ pageData, openModal, setOpenModal, userPermissions, updateTableInstance }} />}
        />
    )
}

const tableCustomersDispatch = {
    setEmployees: (payload: EmployeesPayload) => ({ type: 'CHANGE_EMPLOYEE', payload }),
}

const mapTableCustomersConnector = (state: AllReduxPayloads) => ({ employees: state.employees })
const tableCustomersConnect = connect(mapTableCustomersConnector, tableCustomersDispatch)
const tableCustomersLoading = withLoading(TableCustomers, [{ fetchUrl: '/api/app/employee/getAllEmployees', propName: 'employees', setFunctionName: 'setEmployees' }])
const TableCustomersConnect = tableCustomersConnect(tableCustomersLoading)
export default Customers